import posthogAnalytics from "./posthog";

/**
 * Tracks an analytics event with the standard Accounts prefix.
 *
 * Every event is sent as "Accounts:<eventName>" with `platform: "accounts"`
 * injected into its properties. This follows the same convention used across
 * all CodeDesign applications (Dashboard, Builder, LandingPage).
 *
 * @param {string} eventName  PascalCase "Area:Action" name, e.g. "Auth:LoginSubmitted"
 * @param {Object} properties Additional event properties (optional)
 */
export function trackEvent(eventName, properties = {}) {
  try {
    posthogAnalytics.track(`Accounts:${eventName}`, {
      platform: "accounts",
      ...properties,
    });
  } catch (e) {
    // analytics should never crash the app
  }
}

// Re-export the PostHog instance for identify / getState usage
export { posthogAnalytics as analytics };
